import { FormControlLabel, Switch, SwitchProps, styled } from "@mui/material";
import * as React from "react";

declare const window: any;

export default function ContactContainer({
    colors,
    isContactBtn,
    setIsCotizacion,
    setIsContactModal
}: any) {

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00FF;
    const B = f & 0x0000FF;
    return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
  };

    return (
        <div
            className={`setting-boton-contacto`}
            style={{backgroundColor: colors?.main_buttons}}
            onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = darkenColor(colors?.main_buttons, -0.2);
            }}
            onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = colors?.main_buttons;
            }}
            onClick={() => {setIsContactModal(true); setIsCotizacion(false);}}
        >
            <img src="./UI/contacto/Icon.svg" alt="" />
            Contáctanos
        </div>
    );
}